import React, { ReactElement } from 'react';
import { View } from 'react-native';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function KitTouchPassThroughView({
  style = {},
  onLayout = () => null,
  children,
}: any): ReactElement {
  return (
    <View
      onLayout={onLayout}
      style={{
        // usage: do not apply a background color here, otherwise passing touches through to underlying native views will fail on iOS
        flex: 1,
        ...style,
      }}
      collapsable={false} // required to achieve expected alignment on Android}
      pointerEvents='box-none' // required for passing touches through to native player on Android
    >
      {children}
    </View>
  );
}
